import {QueryFunctionContext} from 'react-query';
import request from '../../axios';

const getOptionalAttributes = async (ctx: QueryFunctionContext) => {
  const {data}: {data: IAttributeData[]} = await request.get(
    `api/v2/store/attribute-list?type=${ctx.queryKey[1]}`,
  );

  return data;
};

export default getOptionalAttributes;
